import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const DetailAppro = () => {
    const { appro } = useLocation().state;
    const table = appro?.produits || [];

    // Totaux
    const total_qte = table.reduce((sum, p) => sum + parseFloat(p.quantite), 0);
    const total_pau = table.reduce((sum, p) => sum + parseFloat(p.pau) * parseFloat(p.quantite), 0);
    const total_pvu = table.reduce((sum, p) => sum + parseFloat(p.pvu) * parseFloat(p.quantite), 0);
    const total_qte_vendu = table.reduce((sum, p) => sum + parseFloat(p.vendu), 0);

    const exportPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        // 📌 Titre principal
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(
            `DÉTAIL VENTE - CONTENEUR: ${appro?.conteneur?.toUpperCase()}`,
            14,
            15
        );

        // 📌 Sous-titre
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("DÉTAIL INFORMATIONS D'ACHAT", 14, 25);

        // 📌 Tableau Infos Achat (3 colonnes comme dans ton JSX)
        autoTable(doc, {
            startY: 30,
            head: [["", "", ""]],
            body: [
                [
                    // Colonne gauche
                    `CONTENEUR: ${appro?.conteneur || "N/A"}\n\n` +
                    `MONTANT VENTE: ${appro?.montant_vente || 0}\n\n` +
                    `MONTANT REMISE: ${appro?.remise || 0}\n\n` +
                    `MONTANT SURPLUS: ${appro?.surplus || 0}\n\n` +
                    `TOTAL NET A PAYER: ${appro?.total_net || 0}`,

                    // Colonne milieu
                    `MONTANT PAYE: ${appro?.total_paye || 0}\n\n` +
                    `MONTANT IMPAYE: ${(parseFloat(appro?.total_net) - parseFloat(appro?.total_paye)) || 0}\n\n` +
                    `MONT.STOCK RESTANT: ${appro?.montant_stock_reste || 0}\n\n` +
                    `TOTAL REVENTE REL DU C: ${(parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste)) || 0}\n\n` +
                    `PRIX DU CONTENEUR: ${(appro?.Prix * appro?.valeur_du_jour) || 0}`,

                    // Colonne droite
                    `DEPENSE TOTAL DU CONTENEUR: ${appro?.depense || 0}\n\n` +
                    `MONTANT DE REVIENT: ${appro?.Montant || 0}\n\n` +
                    `BENEFICE REEL: ${((parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste)) - (appro?.Montant || 0)) || 0}\n\n` +
                    `BENEFICE VIRTUEL: ${((+appro?.montant_achat || 0) - (+appro?.Montant || 0)) || 0}\n\n` +
                    `DIFFERENCE ENTRE BENEFICES: ${(((parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste)) - (appro?.Montant || 0)) -
                        ((+appro?.montant_achat || 0) - (+appro?.Montant || 0))) || 0
                    }`
                ]
            ],
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 3, valign: "top" },
            headStyles: { fillColor: [230, 230, 230], textColor: 20 },
        });

        // 📌 Tableau Produits
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 10,
            head: [
                [
                    "N°",
                    "Produit",
                    "PAU",
                    "Qte Appro",
                    "Mont. Achat",
                    "PVU",
                    "Mont. Vente",
                    "Qte Vendu",
                    "Qte Restante",
                ],
            ],
            body: table.map((prod, index) => [
                index + 1,
                prod.produit,
                prod.pau,
                prod.quantite,
                prod.pau * prod.quantite,
                prod.pvu,
                prod.pvu * prod.quantite,
                prod.vendu,
                prod.quantite - prod.vendu,
            ]),
            foot: [
                [
                    { content: "Totaux", colSpan: 3, styles: { halign: "center" } },
                    total_qte,
                    total_pau,
                    "",
                    total_pvu,
                    total_qte_vendu,
                    total_qte - total_qte_vendu,
                ],
            ],
            styles: { fontSize: 9 },
            headStyles: { fillColor: [0, 102, 204] },
            footStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
        });

        // 📥 Sauvegarde
        doc.save(`Detail_Conteneur_${appro?.conteneur || "N_A"}.pdf`);
    };

    return (
        <div className="p-2">
            <div className="row align-items-center">
                <div className="h5 text-primary w-auto ">
                    DETAIL DU CONTENEUR: {appro?.conteneur?.toUpperCase()}
                </div>
                <button
                    className="btn btn-primary ms-auto float-end btn-sm w-auto"
                    onClick={exportPDF}
                >
                    <i className="bx bx-printer"></i> Export PDF
                </button>
            </div>

            <div className="row">

                <div className="p-2 table-responsive"  >

                    <h6>DETAIL INFORMATIONS D'ACHAT</h6>

                    <div className="row mt-3 row-cols-1 row-cols-md-3 my-2">
                        {/* Colonne de gauche */}
                        <div className="col">
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary  " >CONTENEUR: </span>
                                <span className=" px-2">{appro?.conteneur}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2">MONTANT VENTE</span>
                                <span className=" px-2">{parseFloat(appro?.montant_vente)?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONTANT REMISE</span>
                                <span className=" px-2 text-danger">{appro?.remise?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONTANT SUR PLUS</span>
                                <span className=" px-2">{appro?.surplus?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">TOTAL NET A PAYER</span>
                                <span className=" px-2">{appro?.total_net?.toLocaleString()}</span>
                            </div>
                        </div>
                        <div className="col">
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONTANT PAYE</span>
                                <span className=" px-2">{appro?.total_paye?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONTANT IMPAYE</span>
                                <span className=" px-2">{(parseFloat(appro?.total_net) - parseFloat(appro?.total_paye))?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONT.STOCK RESTANT</span>
                                <span className=" px-2">{appro?.montant_stock_reste?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <label className="bg-secondary-subtle text-secondary px-2  ">TOTAL REVENTE REL DU C</label>
                                <span className=" px-2">{(parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste))?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">PRIX DU CONTENEUR EN GNF</span>
                                <span className=" px-2">{(appro?.Prix * appro.valeur_du_jour)?.toLocaleString()}</span>
                            </div>

                        </div>

                        {/* Colonne de droite */}
                        <div className="col">
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">DEPENSE TOTAL DU CONTENEUR</span>
                                <span className=" px-2">{appro?.depense?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">MONTANT DE REVIENT EN GNF</span>
                                <span className=" px-2">{appro?.Montant?.toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">BENEFICE REEL DU CONTENEUR</span>
                                <span className=" px-2">{((
                                    (parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste)) - (appro.Montant))
                                ).toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">BENEFICE VIRTUEL DU CONTENEUR</span>
                                <span className=" px-2">{((+appro?.montant_achat || 0) - (+appro?.Montant || 0)).toLocaleString()}</span>
                            </div>
                            <div className="mb-2 card  ">
                                <span className="bg-secondary-subtle text-secondary px-2  ">DIFFERENCE ENTRE LES BENEFICES</span>
                                <span className=" px-2">{
                                    (((parseFloat(appro?.total_net) + parseFloat(appro?.montant_stock_reste)) - (appro.Montant)) - ((+appro?.montant_achat || 0) - (+appro?.Montant || 0))).toLocaleString()
                                }</span>
                            </div>
                        </div>
                    </div>

                    <h6>LISTE DES PRODUITS</h6>
                    <table className="table table-striped table-hover shadow table-bordered border-primary">
                        <thead className="table-dark border-primary">
                            <tr className="text-center">
                                <th>N°</th>
                                <th>Produit</th>
                                <th >PAU</th>
                                <th>Qte appro</th>
                                <th>Mont. Achat</th>
                                <th >PVU</th>
                                <th>Mont. Vente</th>
                                <th>qte vendu</th>
                                <th>qte restante</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                table?.map((prod, index) => (
                                    <tr key={index + 1}>
                                        <td>
                                            {index + 1}
                                        </td>
                                        <td>{prod.produit}</td>
                                        <td className="-subtle">{`${(prod?.pau?.toLocaleString())} GNF`}</td>
                                        <td>{prod.quantite}</td>
                                        <td>{`${((+prod.pau) * (+prod.quantite))?.toLocaleString()} GNF`}</td>
                                        <td className="bg-success-subtle">{`${prod?.pvu?.toLocaleString()} GNF`}</td>
                                        <td>{`${((+prod.pvu) * (+prod.quantite))?.toLocaleString()} GNF`}</td>
                                        <td>{prod.vendu}</td>
                                        <td>{+prod.reste}</td>

                                    </tr>
                                ))
                            }
                            <tr className="align-middle">
                                <td colSpan={3} className="text-center fw-bold fs-3">Totaux</td>
                                <td className="fw-bold">{total_qte}</td>
                                <td className="fw-bold">{(total_pau)?.toLocaleString()} GNF</td>
                                <td className="fw-bold"></td>
                                <td className="fw-bold">{(total_pvu)?.toLocaleString()} GNF</td>
                                <td className="fw-bold">{total_qte_vendu}</td>
                                <td className="fw-bold">{total_qte - total_qte_vendu}</td>
                            </tr>
                        </tbody>
                    </table>


                    <table className="table table-striped table-bordered" hidden>
                        <thead className="table-dark">
                            <tr>
                                <th>N°</th>
                                <th>LIBELE</th>
                                <th>VALEUR</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td>DEVISE</td>
                                <td>{appro?.devise}</td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td>PRIX DU CONTENEUR EN DEVISE</td>
                                <td>{appro?.Prix?.toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td>VALEUR DU JOUR</td>
                                <td>{appro?.valeur_du_jour?.toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td>PRIX DU CONTENEUR EN GNF</td>
                                <td>{(appro?.valeur_du_jour * appro?.Prix)?.toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td>DEPENSE TOTAL EN GNF</td>
                                <td>{(appro?.depense)?.toLocaleString()}</td>
                            </tr>
                            <tr className="fw-bold">
                                <td>06</td>
                                <td>MONTANT TOTAL DE REVIENT EN GNF</td>
                                <td>{(appro?.Montant)?.toLocaleString()}</td>
                            </tr>
                            <tr className="fw-bold bg-success-subtle">
                                <td>07</td>
                                <td>TRANSITAIRE</td>
                                <td>{(appro?.transitaire)?.toUpperCase()}</td>
                            </tr>
                        </tbody>
                    </table>


                </div>



            </div>
        </div>
    );
};

export default DetailAppro;
